import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MenuItem, Select, TextField, Typography } from '@mui/material';
import { Controller, useWatch } from 'react-hook-form';
import { FormattedMessage, useIntl } from 'react-intl';
import { ColumnType } from '../api/generated';
import { operatorsWithAutocomplete } from '../api';
import { formatValue, getFormatter } from '../format/valueFormatters';
import { defineStyles } from '../theme';
import ConditionValueAutocomplete from './ConditionValueAutocomplete';
import ConditionValueDateTimePicker from './ConditionValueDateTimePicker';
import { FormattedConditionValueInput } from './FormattedConditionValueInput';
const styles = defineStyles({
    selectInput: {
        minWidth: 150,
    },
    placeholderInput: {
        minWidth: 150,
        '& .MuiInputBase-input': {
            cursor: 'not-allowed',
            pr: '0!important',
        },
    },
});
function ConditionValueField({ control, disabled, andConditionsIndex, orConditionsIndex, fieldName, filterColumn, operator, enableAutocomplete, }) {
    const value = useWatch({
        control,
        name: `andConditions.${andConditionsIndex}.orConditions.${orConditionsIndex}.value`,
    });
    const intl = useIntl();
    const dataType = filterColumn?.dataType;
    const isArrayWithValues = filterColumn?.isArray && Boolean(filterColumn.values);
    if (!filterColumn || !fieldName || !operator)
        return (_jsx(TextField, { variant: "outlined", size: "small", sx: styles.placeholderInput, disabled: true, value: intl.formatMessage({
                id: 'tableFiltering.value.placeholder',
                defaultMessage: 'Value',
            }) }));
    if (disabled) {
        const displayVal = filterColumn ? formatValue(value, filterColumn.format) : value?.toString?.();
        return _jsx(Typography, { children: displayVal ?? '' });
    }
    if (dataType === ColumnType.Enum || isArrayWithValues)
        return (_jsx(Controller, { control: control, name: `andConditions.${andConditionsIndex}.orConditions.${orConditionsIndex}.value`, render: ({ field }) => (_jsx(Select, { ...field, value: field.value ?? '', variant: "outlined", size: "small", sx: styles.selectInput, placeholder: intl.formatMessage({
                    id: 'tableFiltering.value.placeholder',
                    defaultMessage: 'Value',
                }), children: filterColumn.values?.map((value) => (_jsx(MenuItem, { value: value, children: value }, value))) })) }));
    if (dataType === ColumnType.Boolean)
        return (_jsx(Controller, { control: control, name: `andConditions.${andConditionsIndex}.orConditions.${orConditionsIndex}.value`, render: ({ field }) => (_jsxs(Select, { ...field, value: field.value ?? '', variant: "outlined", size: "small", sx: styles.selectInput, placeholder: intl.formatMessage({
                    id: 'tableFiltering.value.placeholder',
                    defaultMessage: 'Value',
                }), children: [_jsx(MenuItem, { value: true, children: _jsx(FormattedMessage, { id: "common.yes", defaultMessage: "Yes" }) }), _jsx(MenuItem, { value: false, children: _jsx(FormattedMessage, { id: "common.no", defaultMessage: "No" }) })] })) }));
    if ((dataType === ColumnType.String || dataType === ColumnType.Number) &&
        operatorsWithAutocomplete.includes(operator) &&
        enableAutocomplete)
        return (_jsx(ConditionValueAutocomplete, { control: control, orConditionsIndex: orConditionsIndex, andConditionsIndex: andConditionsIndex, fieldName: fieldName, dataType: dataType, columnFormat: filterColumn.format, operator: operator }));
    if (dataType === ColumnType.Timestamp) {
        return (_jsx(ConditionValueDateTimePicker, { control: control, andConditionsIndex: andConditionsIndex, orConditionsIndex: orConditionsIndex }));
    }
    const formatter = getFormatter(filterColumn.format);
    if (formatter && operator) {
        const valuePath = `andConditions.${andConditionsIndex}.orConditions.${orConditionsIndex}.value`;
        return (_jsx(Controller, { control: control, name: valuePath, render: ({ field }) => (_jsx(FormattedConditionValueInput, { field: field, columnFormat: filterColumn.format, operator: operator })) }));
    }
    if (dataType === ColumnType.String) {
        return (_jsx(Controller, { control: control, name: `andConditions.${andConditionsIndex}.orConditions.${orConditionsIndex}.value`, render: ({ field }) => (_jsx(TextField, { ...field, value: field.value ?? '', variant: "outlined", size: "small", sx: styles.selectInput, onPaste: (e) => {
                    e.preventDefault();
                    field.onChange(e.clipboardData.getData('text/plain').trim());
                } })) }));
    }
    return null;
}
export default ConditionValueField;
//# sourceMappingURL=ConditionValueField.js.map